@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ProgressFlow {
  @extend %font-family-primary;

  display: flex;
  min-width: 768px;
  white-space: nowrap;
  border-radius: 6px 6px 0 0;
  border-bottom: 1px solid $theme-color-secondary-button-border;
  flex-direction: row;
  column-gap: 8px;
  padding: 15px 32px;
  min-height: 40px;
  align-items: center;
  align-self: stretch;

  .FlowItem {
    display: flex;
    align-items: center;
    column-gap: 8px;
  }

  .Divider {
    width: 80px;
  }
}
